module.exports = __webpack_public_path__ + "img/smartlocal2.b2a65fe1.png";